<template>
  <div class="partner-worker-column tw-cursor-pointer" @click="openWorkerDetails">
    <WdsAvatarLabel
      v-if="showAvatar"
      :path="avatarPath"
      :initials="initials || undefined"
      :text="name"
      :sub-text="showEmail ? email || undefined : undefined"
      truncated
      class="worker-avatar-label"
    />
    <div v-else class="tw-flex tw-flex-col tw-items-start tw-justify-center">
      <WdsText :sub-text="showEmail ? email || undefined : undefined" :title="name">
        {{ name }}
      </WdsText>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsAvatarLabel, WdsText } from '@worksome/wds-components'
import { getAvatarPath } from '@/utils/avatar'
import { useTablePanels } from '@/components/GraphqlDataTable/useTablePanels'

const { openPartnerWorkerDetailPanel } = useTablePanels()

const props = withDefaults(
  defineProps<{
    workerId: string
    name: string
    email?: string | null
    avatar?: string | null
    initials?: string | null
    employmentId?: string | null
    showAvatar?: boolean
    showEmail?: boolean
  }>(),
  {
    email: null,
    avatar: null,
    initials: null,
    employmentId: null,
    showAvatar: false,
    showEmail: false,
  },
)

const avatarPath = computed(() => getAvatarPath(props.avatar, props.workerId))

const openWorkerDetails = () => {
  openPartnerWorkerDetailPanel({
    workerId: props.workerId,
    employmentId: props.employmentId ?? undefined,
  })
}
</script>

<style scoped>
.partner-worker-column {
  min-width: 200px;
  max-width: 250px;
}

.worker-avatar-label {
  width: 100%;
}

/* Ensure avatar displays properly in table context */
.worker-avatar-label :deep(.wds-avatar-label) {
  align-items: flex-start;
}

.worker-avatar-label :deep(.wds-avatar) {
  flex-shrink: 0;
}
</style>
